import React from "react";
import { Sparkles } from "lucide-react";
import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { setMode } from "@redux/slices/archiSlice";
import { isProductionEnvironment } from "@shared/navigation/SideMenu/sideMenuEnv";

/**
 * Floating button bottom-right that summons the Archi sidebar. Hidden
 * once the sidebar is open or expanded — the user closes from inside
 * the sidebar header instead.
 *
 * Collapsed by default (icon-only circle) to avoid overlapping wizard
 * footers and other bottom-right UI. Expands to show the label on
 * hover or keyboard focus.
 */
const ArchiFab: React.FC = () => {
  const dispatch = useAppDispatch();
  const mode = useAppSelector((s) => s.archi.mode);

  // PROD GATE: Archi chat is disabled in production. To enable Archi
  // in prod, REMOVE this line (and the matching guard in ArchiSidebar.tsx).
  if (isProductionEnvironment()) return null;
  if (mode !== "collapsed") return null;

  return (
    <button
      type="button"
      onClick={() => dispatch(setMode("open"))}
      className="
        group absolute right-4 bottom-4 z-40
        flex items-center
        h-11 w-11 hover:w-32 focus-visible:w-32
        rounded-full
        bg-semantic-bg-brand-bold-secondary text-white
        shadow-lg
        hover:opacity-90 active:opacity-80
        transition-[width,opacity] duration-300 ease-out
        overflow-hidden
        focus:outline-none focus-visible:ring-2 focus-visible:ring-white/40
      "
      aria-label="Ask Archi"
    >
      <span className="flex items-center justify-center w-11 h-11 flex-shrink-0">
        <Sparkles className="w-5 h-5" />
      </span>
      <span
        className="
          text-sm font-medium whitespace-nowrap
          opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100
          -ml-1 pr-4
          transition-opacity duration-200 ease-out
        "
      >
        Ask Archi
      </span>
    </button>
  );
};

export default ArchiFab;
